import TableDiff from "admin/components/TableDiff";
import { TABLE_MANAGEMENT_PAGE_TITLE } from "admin/types/constants/page-titles";
import useAppHeader from "~/contexts/header";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { AdminPage } from "~/pages/manifold-nextgen/components/admin/AdminPage";

const Tables = ({ isNextGen = false }: { isNextGen?: boolean }) => {
  useDocumentTitle(TABLE_MANAGEMENT_PAGE_TITLE);
  useAppHeader({ title: TABLE_MANAGEMENT_PAGE_TITLE });

  return (
    <AdminPage
      title="Table Admin"
      description="Compare a schema's Snowflake tables against what the Manifold platform has registered."
      constrainWidth={isNextGen}
      fillHeight
    >
      <TableDiff />
    </AdminPage>
  );
};

export default Tables;
